// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"433d45e6","453":"3c57f140"}[chunkId] + ".chunk.js";
};